import React, { useState, useEffect } from "react";
import {
    Typography,
    Divider,
    Button,
    IconButton,
    FormControlLabel,
    Box,
    Paper,
    Alert,
    Checkbox,
    TextField,
    FormGroup,
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HomeIcon from '@mui/icons-material/Home';
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import CancelIcon from '@mui/icons-material/Cancel';
import ModalAssinaturaCancelada from "./ModalAssinaturaCancelada";

const CancelarAssinatura = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);

    const [motivosSelecionados, setMotivosSelecionados] = useState([]);
    const [outroMotivo, setOutroMotivo] = useState("");
    const [erroValidacao, setErroValidacao] = useState(false);
    const [mensagemErro, setMensagemErro] = useState("");
    const [openModalAssinaturaCancelada, setOpenModalAssinaturaCancelada] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const motivos = [
        "Preço alto",
        "Não estou usando o serviço",
        "Encontrei outra solução",
        "Problemas técnicos",
        "Insatisfação com o suporte"
    ];

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarNotificacoes`,
                { email: localStorage.getItem("email") },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`
                    }
                }
            );

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes);
            }
        };

        getNotify();
    }, []);

    const handleCheckboxChange = (motivo) => {
        if (motivosSelecionados.includes(motivo)) {
            setMotivosSelecionados(prev => prev.filter(m => m !== motivo));
        } else {
            setMotivosSelecionados(prev => [...prev, motivo]);
        }
    };

    const handleCancelar = async () => {
        if (motivosSelecionados.length === 0 && outroMotivo.trim() === "") {
            setErroValidacao(true);
            setMensagemErro("Por favor, selecione ou informe ao menos um motivo para o cancelamento.");
            return;
        }

        setErroValidacao(false);
        setMensagemErro("");

        const dadosCancelamento = {
            motivosSelecionados,
            outroMotivo: outroMotivo.trim()
        };

        console.log("Dados de cancelamento:", dadosCancelamento);

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/cancelarAssinatura`,
            { ...dadosCancelamento, idAssinaturaAsaas: user?.assinatura?.idAssinaturaAsaas },
            {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            }
        );

        if (response.status === 200) {
            fetchUser();
            setOpenModalAssinaturaCancelada(true);
        }
    };


    return (
        <>
            <HeaderDashboard
                userActive={userActive}
                setOpenModalNotificacao={setOpenModalNotificacao}
                notificacoes={notificacoes.length}
            />
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../Dashboard/Assinatura")}
                                >
                                    <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Assinaturas & Cobranças
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <CancelIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Cancelamento de Assinatura
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Box
                    sx={{
                        width: window.innerWidth > 800 ? "80%" : "100%",
                        display: "flex",
                        justifyContent: "center",
                        py: 4,
                        margin: "0 auto",
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            width: "100%",
                            // maxWidth: "900px",
                            borderRadius: "20px",
                            p: 4,
                        }}
                    >
                        {/* Cabeçalho */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                mb: 3,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: "12px",
                                    bgcolor: "#FEECEC",
                                    color: "#E53935",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "24px",
                                }}
                            >
                                ⚠️
                            </Box>

                            <Box>
                                <Typography
                                    variant="h4"
                                    fontWeight={700}
                                >
                                    Cancelamento de Assinatura
                                </Typography>

                                <Typography color="text.secondary">
                                    Sua opinião nos ajuda a melhorar.
                                </Typography>
                            </Box>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        {/* Aviso */}
                        <Box
                            sx={{
                                p: 3,
                                borderRadius: "16px",
                                bgcolor: "#FFF5F5",
                                border: "1px solid #FFD6D6",
                                mb: 4,
                            }}
                        >
                            <Typography
                                fontWeight={700}
                                color="error"
                                mb={1}
                            >
                                Sentiremos sua falta!
                            </Typography>

                            <Typography color="text.secondary">
                                Antes de concluir o cancelamento, gostaríamos de entender
                                o motivo da sua decisão. Seu feedback é fundamental para
                                melhorarmos nossos serviços.
                            </Typography>
                        </Box>

                        {/* Motivos */}
                        <Typography
                            variant="h6"
                            fontWeight={600}
                            mb={2}
                        >
                            Qual o principal motivo do cancelamento?
                        </Typography>

                        <Paper
                            variant="outlined"
                            sx={{
                                p: 2,
                                borderRadius: "16px",
                                mb: 3,
                                bgcolor: "#FAFAFA",
                            }}
                        >
                            <FormGroup>
                                {motivos.map((motivo, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={motivosSelecionados.includes(
                                                    motivo
                                                )}
                                                onChange={() =>
                                                    handleCheckboxChange(motivo)
                                                }
                                            />
                                        }
                                        label={motivo}
                                    />
                                ))}
                            </FormGroup>
                        </Paper>

                        {/* Outro motivo */}
                        <TextField
                            label="Outro motivo (opcional)"
                            placeholder="Conte-nos mais detalhes..."
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={4}
                            value={outroMotivo}
                            onChange={(e) => setOutroMotivo(e.target.value)}
                        />

                        {/* Erro */}
                        {erroValidacao && (
                            <Alert
                                severity="error"
                                sx={{ mt: 3 }}
                            >
                                {mensagemErro}
                            </Alert>
                        )}

                        {/* Consequências */}
                        <Box
                            sx={{
                                mt: 4,
                                p: 3,
                                borderRadius: "16px",
                                bgcolor: "#F5F6F8",
                            }}
                        >
                            <Typography
                                fontWeight={700}
                                mb={1}
                            >
                                Ao cancelar:
                            </Typography>

                            <ul
                                style={{
                                    margin: 0,
                                    paddingLeft: "20px",
                                    color: "#666",
                                }}
                            >
                                <li>Você manterá acesso até o fim do ciclo atual.</li>
                                <li>As próximas cobranças serão interrompidas.</li>
                                <li>Os recursos premium serão desativados.</li>
                                <li>Você poderá retornar quando desejar.</li>
                            </ul>
                        </Box>

                        {/* Ações */}
                        <Box
                            sx={{
                                mt: 4,
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 2,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="success"
                                size="large"
                                onClick={() => navigate("../Dashboard/assinatura")}
                            >
                                Manter Assinatura
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                size="large"
                                onClick={handleCancelar}
                                sx={{
                                    minWidth: 240,
                                    fontWeight: 700,
                                    borderRadius: "12px",
                                }}
                            >
                                Confirmar Cancelamento
                            </Button>
                        </Box>
                    </Paper>
                </Box>
            </div>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ModalAssinaturaCancelada
                openModalAssinaturaCancelada={openModalAssinaturaCancelada}
                setOpenModalAssinaturaCancelada={setOpenModalAssinaturaCancelada}
            />
        </>
    );
};

export default CancelarAssinatura;
